import React, { useState, useEffect } from 'react';
import { Breadcrumb, Layout, theme, Space, Form, Input, InputNumber, Button, Select, DatePicker, Col, Row, Switch, message, Spin } from 'antd';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { MAINAPIURL, APPBACKGROUND_COLOR } from '../appsettings.js';
import { AlertError, AlertSuccess } from '../usableclasses.js';
import moment from 'moment';

const { Content } = Layout;
const { Option } = Select;

const VendorEdit = () => {

    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");

    const { id } = useParams();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const { token: { colorBgContainer, borderRadiusLG } } = theme.useToken();
    const [loading, setLoading] = useState(false);
    const [vendorData, setVendorData] = useState(null);
    const [countries, setCountries] = useState([]);

    useEffect(() => {
        setLoading(true);
        axios.get(`${ApiURL}/master/counrty/dropdown`, {
            headers: { SystemAccessToken: TOKEN }
        }).then(response => {
            setCountries(response.data);
        }).catch(error => {
            AlertError('Failed to load country list');
        });
        setLoading(false);
        fetchVendorDetails();
    }, []);

    const fetchVendorDetails = async () => {
        setLoading(true);
        try {
            const headers = { SystemAccessToken: localStorage.getItem("AUTHCODE") };
            const response = await axios.get(`${MAINAPIURL}/vendor/details/${id}`, { headers });

            // Ensure date field is converted properly
            const vendorDetails = {
                ...response.data,
                vendorRegDate: response.data.vendorRegDate ? moment(response.data.vendorRegDate) : null
            };

            setVendorData(vendorDetails);
            form.setFieldsValue(vendorDetails);
        } catch (error) {
            AlertError("Failed to load vendor details.");
        } finally {
            setLoading(false);
        }
    };

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const payload = { ...values, vendorId: id, updatedBy: UPDATED_BY };
            const headers = { SystemAccessToken: TOKEN };
            await axios.post(`${MAINAPIURL}/vendor/edit`, payload, { headers });
            AlertSuccess("Vendor updated successfully.");
            navigate("/master/vendorlist");
        } catch (error) {
            AlertError("Failed to update vendor.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading} tip="Processing...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
                <Headerdiv />
                <Content style={{ padding: '10px' }}>
                    <Breadcrumb style={{ margin: "16px 0" }}>
                        <Breadcrumb.Item>Vendor</Breadcrumb.Item>
                        <Breadcrumb.Item ><Link to={'/master/vendorlist'}>Vendor Management</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>Vendor Edit</Breadcrumb.Item>
                    </Breadcrumb>
                    <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG }}>
                        <Space direction="vertical" style={{ width: "100%", padding: "15px" }}>
                            <h2>Vendor Update</h2>
                            <Form form={form} layout="vertical" onFinish={onFinish}>
                                <Row>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Vendor Type" name="vendorType" rules={[{ required: true, message: ' ${label} is required!', }]}>
                                            <Select>
                                                <Select.Option value="Person">Person</Select.Option>
                                                <Select.Option value="Business">Business</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={18} style={{ padding: '5px' }}>
                                        <Form.Item label="Vendor Name" name="vendorName" rules={[{ required: true, max: 150, message: ' ${label} is required!', }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Document Type" name="vendorRegDocType" rules={[{ required: true, message: ' ${label} is required!', }]}>
                                            <Select>
                                                <Select.Option value="NIC">NIC</Select.Option>
                                                <Select.Option value="BR">BR</Select.Option>
                                                <Select.Option value="PASSPORT">Passport</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Registration Country" name="vendorRegCountry" rules={[{ required: true, message: ' ${label} is required!', }]}>
                                            <Select>
                                                {countries.map((country) => (
                                                    <Select.Option key={country.id} value={country.id}>{country.label}</Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Registration No" name="vendorRegNo" rules={[{ required: true, max: 20, message: ' ${label} is required!', }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Tax No" name="vendorTaxNo" rules={[{ max: 20 }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Hotline" name="vendorHotline" rules={[{ max: 15 }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Office Line" name="vendorOfficeLine" rules={[{ required: true, max: 15, message: ' ${label} is required!', }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Email" name="vendorEmail" rules={[{ type: 'email', max: 150 }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Website" name="vendorWeb" rules={[{ max: 150 }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={24} style={{ padding: '5px' }}>
                                        <Form.Item label="Address" name="vendorAddress" rules={[{ required: true, max: 200, message: ' ${label} is required!', }]}>
                                            <Input.TextArea />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Current Balance" name="vendorCurrentBalance" rules={[{ required: true, message: ' ${label} is required!', }]} >
                                            <InputNumber disabled={'true'} min={0} step={0.01} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Registration Date" name="vendorRegDate" rules={[{ required: true, message: ' ${label} is required!', }]}>
                                            <DatePicker format='YYYY-MM-DD' />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item label="Is Verified Customer" name="vendorIsVerified" valuePropName="checked">
                                            <Switch />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                        <Form.Item>
                                            {/* <Button style={{ width: "100%" }} type="primary" htmlType="submit" loading={loading}>
                                                {loading ? "Registering..." : "Register"}
                                            </Button> */}
                                            <Button type="primary" style={{ marginRight: '5px' }} htmlType="submit" loading={loading}>Update</Button>

                                            <Button onClick={() => navigate("/vendormanagement")} disabled={loading}>Cancel</Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Space>
                    </div>
                </Content>
                <Footerdiv />
            </Layout>
        </Spin>
    );
};

export default VendorEdit;
